import { render, staticRenderFns } from "./StockDrawer.vue?vue&type=template&id=b449e254&scoped=true"
import script from "./StockDrawer.vue?vue&type=script&lang=js"
export * from "./StockDrawer.vue?vue&type=script&lang=js"
import style0 from "./StockDrawer.vue?vue&type=style&index=0&id=b449e254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b449e254",
  null
  
)

export default component.exports